import { hasSlot } from '../../utils/utils.js';

var script = {
  name: 'PendoFilterBar',
  computed: {
    hasBottom() {
      return hasSlot(this, 'bottom');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-filter-bar.vue2.js.map
